<template>
  <div class="page-content">
    <!-- 头部 -->
    <home-header></home-header>
    <!-- 头部-->
    <!-- banner、tab-->
    <div class="banner-info"></div>
    <div class="menu">
      <mt-navbar v-model="selected">
        <mt-tab-item v-for="(item, index) in tabList" :name="index" :key="index" :id="index"
                     @click.native="fetchData(item)">{{ item.value }}
        </mt-tab-item>
      </mt-navbar>
      <!-- banner、tab -->
      <!-- 内容 -->
      <div class="cont">
        <ul class="news-item" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading"
            infinite-scroll-distance="120">
          <li class="item" v-for="item of alumniInformationList" :key="item.id">
            <router-link :to="{path: '/alumniDetail', query: {id: item.id }}">
              <div class="item-img-wrapper">
                <img :src="imgUrl + item.mainPic + '&type=thumb'" alt="" class="item-image">
              </div>
              <div class="item-info">
                <p class="item-title">{{ item.informationTitle }}</p>
                <p class="item-time">{{ item.createTime | dateFmt('YYYY-MM-DD') }}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 内容 -->
      <div v-show="haveMoreData && loading" class="loading">
        <mt-spinner type="fading-circle" color="#e58111"></mt-spinner>
        <!--加载中-->
      </div>
      <div v-show="!haveMoreData" class="load-text">已加载完毕 ~</div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";
import {getAlumniInformation} from "@/apis/apis.js";

export default {
  name: "AlumniStyle",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      selected: 0,
      loading: false,
      imgUrl: "http://file.hainayx.com/file-server/download?fileUrl=",
      tabList: [{
        value: "校友专访",
        key: "1"
      }, {
        value: "校友大事记",
        key: "2"
      }],
      nowCountry: "1",
      nowPageNum: "1",
      haveMoreData: true,
      alumniInformationList: []
    };
  },
  methods: {
    fetchData(item) {
      this.displayType = item.key;
      this.nowPageNum = "1";
      this.haveMoreData = true;
      this.loading = false;
      this.fetchList(this.displayType, this.nowPageNum);
    },
    async fetchList(key, pageNum) {
      let params = {
        pageSize: "10",
        pageNum: pageNum,
        displayType: key,
        status: 1
      };
      try {
        let {
          data
        } = await getAlumniInformation(params);
        if (data.code === 1000) {
          if (data.data.content.length === 0) {
            this.haveMoreData = false;
          }
          if (pageNum === "1") {
            this.alumniInformationList = data.data.content;
          } else {
            this.alumniInformationList = this.alumniInformationList.concat(data.data.content);
          }
        } else {
        }
      } catch (err) {
        console.log(err);
      }
    },
    loadMore() {
      if (!this.haveMoreData) {
        this.loading = true;
        return;
      }
      console.log("触发了loadMore");
      this.loading = true;
      setTimeout(() => {
        this.nowPageNum++;
        this.fetchList(this.displayType, this.nowPageNum);
        console.log("触发loadMore结束");
        this.loading = false;
      }, 1000);
    }
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">
.page-content {
  .banner-info {
    width: 100%;
    height: 200px;
    background: url("../../assets/images/banner002.png");
    background-size: 100% 100%;
  }

  .cont {
    margin-top: 16px;
    background: #fff;
  }
}


/* tab切换样式 */

/deep/ .mint-navbar {
  height: 90px;
  overflow-x: auto;
  white-space: nowrap;
  border-bottom: 15px solid #F0F0F0;
}

/deep/.mint-navbar ::-webkit-scrollbar {
  display: none;
}

/deep/ .mint-navbar .mint-tab-item {
  min-width: 120px;
  color: #333;
  padding: 0;
}

/deep/ .mint-tab-item.is-selected {
  font-size: 29px;
  color: #e58111;
  border-bottom: none;
}

/deep/ .mint-tab-item-label {
  font-size: 26px;
  line-height: 80px;
}

.item {
  height: 203px;
  border-bottom: 1px solid #ccc;
  margin-left: 22px;
  margin-right: 22px;
}

.item-img-wrapper {
  width: 228px;
  height: 150px;
  display: inline-block;
  margin-top: 26px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}

.item-image {
  width: 228px;
  height: 150px;
}

.item-info {
  width: 60%;
  float: right;
  margin-top: 30px;
}

.item-title {
  font-size: 29px;
  color: rgba(51, 51, 51, 1);
  line-height: 46px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 95px;
}

.item-time {
  font-size: 24px;
  color: #999;
  line-height: 55px;
}

/*加载中*/

/deep/ .mint-spinner-fading-circle-circle {
  left: 340px;
  top: 20px;
  width: 50px;
  height: 50px;
  text-align: center;
}

.loading {
  height: 100px;
  text-align: center;
  line-height: 100px;
}

.load-text {
  height: 100px;
  text-align: center;
  line-height: 100px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/alumni-style/index.vue